// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectName-modulename__G5oqH";
export { _1 as "name" }
